<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="form.nickname" placeholder="设计师名称">
                        </el-input>
                        <el-select v-model="typeValue" placeholder="设计师类型">
                            <el-option
                                label="全部"
                                value="BOTH">
                            </el-option>
                            <el-option
                                label="平面设计师"
                                value="GRAPHIC">
                            </el-option>
                            <el-option
                                label="建模设计师"
                                value="MODEL">
                            </el-option>
                        </el-select>
                        <el-cascader
                            v-model="areaValue"
                            :options="provinceOptions"
                            @change="handleChange"
                            clearable placeholder="地区"></el-cascader>
                        <el-select v-model="statusValue" placeholder="状态">
                            <el-option
                                label="启用"
                                value="ENABLE">
                            </el-option>
                            <el-option
                                label="停用"
                                value="DISABLE">
                            </el-option>
                        </el-select>
                        <div class="timeSearch">
                            <span style="color: #b2b2b2;">入驻时间</span>
                            <el-date-picker
                                v-model="createDateValue"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="—"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            >
                            </el-date-picker>
                        </div>
                        <el-select clearable v-model="applicationStatus" placeholder="开户状态">
                            <el-option
                                label="未开户"
                                value="noAccount">
                            </el-option>
                            <el-option
                                label="申请审核中"
                                value="REVIEWING">
                            </el-option>
                            <el-option
                                label="申请已驳回"
                                value="REVIEW_BACK">
                            </el-option>
                            <el-option
                                label="真实性验证中"
                                value="AUTHENTICITY_VERIFYING">
                            </el-option>
                            <el-option
                                label="协议待签署"
                                value="AGREEMENT_SIGNING">
                            </el-option>
                            <el-option
                                label="业务开通中"
                                value="BUSINESS_OPENING">
                            </el-option>
                            <el-option
                                label="已开户"
                                value="COMPLETED">
                            </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>

                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="name"
                                label="设计师名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="type"
                                label="设计类型"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip
                                width="200">
                            </el-table-column>
                            <el-table-column
                                prop="area"
                                label="地区"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="入驻时间"
                                header-align="center"
                                show-overflow-tooltip
                                width="200"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="sort"
                                align="center"
                                header-align="center"
                                label="推荐位" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.sort===0?'':scope.row.sort }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="survival"
                                align="center"
                                header-align="center"
                                :formatter="showSurvival"
                                label="状态" width="100">
                            </el-table-column>
                            <el-table-column
                                prop="applicationStatus"
                                align="center"
                                header-align="center"
                                :formatter="showApplicationStatus"
                                label="开户状态" width="200">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center"
                                width="230">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.status != 'AUDIT'" @click="toDialog(1,scope.row)">查看</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.survival === 'ENABLE'" @click="changeSurvival('DISABLE',scope.row.uuid)">停用</el-button>
                                    <el-button type="text" size="small" v-else @click="changeSurvival('ENABLE',scope.row.uuid)">启用</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.status === 'PASS'" @click="setSortInfo(scope.row)">推荐位</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.status === 'PASS' && scope.row.sort" @click="cancelRecommended(scope.row)">取消推荐</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handlePageChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>


        <!--审核查看弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="800px">
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <h3>认证信息</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">姓名:</div>
                                <div class="name" v-text="designer.nickname">张某某</div>
                            </div>
                            <div class="one-row">
                                <div class="label">性别:</div>
                                <div class="name" v-text="designer.sexCn">男</div>
                            </div>
                            <div class="two-row">
                                <div class="label">证件号码:</div>
                                <div class="name" v-text="designer.identityNo">640000000000000000</div>
                            </div>
                            <div class="two-row">
                                <div class="label">地址:</div>
                                <div class="name" v-text="designer.area+designer.address">宁夏 银川市 金凤区 收到啊吉萨大氨基酸看到大家可别洒家扩大安居客的</div>
                            </div>
                            <div class="two-row">
                                <div class="label">设计师分类:</div>
                                <div class="name" v-text="designer.typeCn">广告设计师、3D模型设计师</div>
                            </div>
                            <div class="two-row">
                                <div class="label">擅长类型:</div>
                                <div class="name" v-text="designer.goodat">工业零件、雕塑文物、儿童玩具</div>
                            </div>
                            <div class="two-row"  style="width:100%">
                                <div class="label">个人介绍:</div>
                                <div class="name" v-text="designer.introduction">收到啊吉萨大氨基酸看到大家可别洒家扩大安居客的收到啊吉萨大氨基酸看到大家可别洒家扩大安居客的收到啊吉萨大氨基酸看到大家可别洒家扩大安居客的</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem" v-if="designer.type != 'MODEL'">
                        <h3>设计师作品</h3>
                        <div class="itemPictureContent">
                            <div class="one-row" v-for="(items, index) in designer.designerAttachmentList" :key="index" v-if="items.attachmentType == 'GRAPHIC'">
                                <div class="image">
                                    <img :src="items.fileUrl" alt="">
                                </div>
                                <div class="name"><div class="label">作品名称：</div><div>{{items.workName}}</div></div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem" v-if="designer.type != 'GRAPHIC'">
                        <h3>设计师模型</h3>
                        <div class="itemPictureContent">
                            <div class="one-row"  v-for="(items, index) in designer.designerAttachmentList" :key="index" v-if="items.attachmentType == 'MODEL'">
                                <div class="image" style="cursor: pointer;">
                                    <img :src="items.modelUrl" alt=""  @click="handPreview(items)">
                                </div>
                                <div class="name"><div class="label">模型名称：</div><div>{{items.workName}}</div></div>
                                <div class="name"><div class="label">模型文件：</div><div style="cursor: pointer;color: #409EFF;"><a :href="items.fileUrl" :download="items.fileName">{{items.fileName}}</a></div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 1">
                    <h3>审核结果</h3>
                    <div class="auditContent">
                        <el-tag type="success" effect="dark" v-if="designer.status == 'PASS'">审核已通过</el-tag>
                        <el-tag type="danger" effect="dark"  v-if="designer.status == 'REJECT'">审核已驳回</el-tag>
                        <div class="cause" v-if="designer.status == 'REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" v-text="designer.reason">撒旦咯技术的案件卡刷点卡大家开始的阿萨的金卡多久啊口水都快就卡死的卡就卡死的卡就卡死的卡</div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 0">
                    <h3>审核</h3>
                    <div class="auditContent">
                        <el-radio-group v-model="auditForm.status">
                            <el-radio label="PASS">通过</el-radio>
                            <el-radio label="REJECT">驳回</el-radio>
                        </el-radio-group>
                        <div class="cause" v-if="auditForm.status === 'REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" style=" width: 100%;">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 5}"
                                    placeholder="请输入驳回原因"
                                    v-model="auditForm.reason">
                                </el-input>
                            </div>
                        </div>
                        <div class="auditEnter">
                            <el-button type="primary" @click="auditSubmit(designer.uuid)">确定</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 3d预览 -->
        <three-d
          ref="threeBox"
          :innerVisible="innerVisible"
          @closeDlog="closeDlog"
        ></three-d>
        <!-- 设置推荐位 -->
        <el-dialog
            title="设置推荐位"
            :visible.sync="sortDialogVisible"
            width="800px">
            <div class="dialogContent">
                <el-form :rules="rules" :model="ruleForm" ref="ruleForm" label-width="120px">
                    <el-form-item prop="sort" label="推荐位">
                        <el-input-number v-model="ruleForm.sort"  :min="1"></el-input-number>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {auditDesigner, designerListByPage,changeDesignerOnAndOff, setDesignerSort} from "../../utils/interface";
    import {mapState, mapMutations} from "vuex";
    import threeD from "../../components/threeD/index";

    export default {
        components: {threeD},
        data() {
            return {
                form: {nickname:'',},
                auditForm: {},
                createDateValue: null,
                typeValue: '',
                areaValue: [],
                statusValue: '',
                applicationStatus:"",
                provinceOptions: this.provinceData,
                tableData: [
                ],
                current: 0,
                pageSize: 10,
                total: 0,
                dialogVisible: false,
                title: '',
                currentAudit: '',
                designer:{},
                innerVisible: false,
                sortDialogVisible:false,
                info:{},
                ruleForm:{
                    sort:'',
                },
                rules: {
                    sort: [
                        {required: true, message: '请设置推荐排序', trigger: 'change'}
                    ],
                },
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.search();
        },
        methods: {
            submit(){
                this.info.sort = this.ruleForm.sort;
                setDesignerSort({designerUuid:this.info.uuid,sort:this.ruleForm.sort}).then((res)=>{
                    if(res.success) {
                        this.$message.success('设置成功！');
                        this.sortDialogVisible = false;
                        this.search();
                    }
                });
            },
            cancelRecommended(item){
                this.$confirm('确定取消推荐吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    setDesignerSort({designerUuid:item.uuid,sort:-1}).then((res)=>{
                        if(res.success) {
                            this.$message.success('设置成功！');
                            this.sortDialogVisible = false;
                            this.search();
                        }
                    });
                }).catch(() => {})
            },
            setSortInfo(item){
                this.info = item;
                if(item.sort!=""){
                    this.ruleForm.sort = item.sort;
                }
                this.sortDialogVisible = true;
            },
            showApplicationStatus(row, column){
                if(row.applicationStatus==null){
                    return "未开户";
                }else if(row.applicationStatus=="REVIEWING"){
                    return "申请审核中";
                }else if(row.applicationStatus=="REVIEW_BACK"){
                    return "申请已驳回";
                }else if(row.applicationStatus=="AUTHENTICITY_VERIFYING"){
                    return "真实性验证中";
                }else if(row.applicationStatus=="AGREEMENT_SIGNING"){
                    return "协议待签署";
                }else if(row.applicationStatus=="BUSINESS_OPENING"){
                    return "业务开通中";
                }else if(row.applicationStatus=="COMPLETED"){
                    return "已开户";
                }
            },
            showSurvival(row, column){
                if(row.survival=="ENABLE"){
                    return "启用";
                }else if(row.survival=="DISABLE"){
                    return "停用";
                }
            },
            //启用停用
            changeSurvival(val,designerUuid){
                let msg = "确定停用设计师吗";
                if(val==='ENABLE'){
                    msg = "确定启用设计师吗";
                }

                this.$confirm(msg, "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    let params={designerUuid:designerUuid,survival:val}
                    console.log(JSON.stringify(params))
                    return changeDesignerOnAndOff(params);
                }).then(() => {
                    this.$message.success("操作成功");
                    this.search();
                }).catch(function() {
                    this.$message.error("操作失败");
                });
            },
            // 地区选择
            handleChange(value) {
                if(value != null && value.length == 3){
                    this.form.province = value[0];
                    this.form.city = value[1];
                    this.form.district = value[2];
                } else if(value != null && value.length == 2){
                    this.form.province = value[0];
                    this.form.city = value[1];
                    this.form.district = value[1];
                }else{
                    this.form.province = null;
                    this.form.city = null;
                    this.form.district = null;
                }
            },
            resetData(){
                this.createDateValue = null;
                this.typeValue = '';
                this.areaValue = '';
                this.statusValue = '';
                this.applicationStatus = '';
                this.form.nickname= "";
                this.form.province = null;
                this.form.city = null;
                this.form.district = null;
                this.form.inputDate = "";
                this.current = 1;
                this.search();
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
            },
            handlePageChange(val) {
                this.current = val;
                this.search();
            },
            search(){
                this.form.type = this.typeValue;
                this.form.status = 'PASS';
                this.form.survival =  this.statusValue;
                this.form.applicationStatus =  this.applicationStatus;
                if(this.createDateValue != null){
                    this.form.inputDate = this.createDateValue.join(" - ");
                }
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                designerListByPage(this.form).then((res)=>{
                    this.tableData = [];
                    if(res != null && res.list != null && res.list.length > 0){
                        this.total = res.total;
                        res.list.forEach((item, index) => {
                            let designer = {};
                            designer.desDetail = item;
                            // if(item.designerCateList != null && item.designerCateList.length > 0){
                            //     let categories = "";
                            //     item.designerCateList.forEach((item, index) => {
                            //         categories += item.categoryName + "、";
                            //     });
                            //     categories = categories.substring(0, categories.length-1);
                            //     designer.desDetail.categories = categories;
                            // }
                            if(item.designerGoodatList != null && item.designerGoodatList.length > 0){
                                let goodat = "";
                                item.designerGoodatList.forEach((item, index) => {
                                    goodat += item.goodatName + "、";
                                });
                                goodat = goodat.substring(0, goodat.length-1);
                                designer.desDetail.goodat = goodat;
                            }

                            designer.uuid = item.uuid;
                            designer.name = item.nickname;
                            if(item.city == item.district){
                                designer.area = item.province + '|' + item.city;
                            }else{
                                designer.area = item.province + '|' + item.city + '|' +item.district;
                            }
                            designer.type = item.typeCn;
                            designer.createTime = item.createTime;
                            designer.status = item.status;
                            designer.survival = item.survival;
                            designer.sort = item.sort;
                            designer.applicationStatus = item.applicationStatus;
                            this.tableData.push(designer);
                        });
                    }else{
                        this.total = 0;
                    }
                });
            },
            // 审核查看
            toDialog(val,designer){
                this.dialogVisible = true;
                this.designer = designer.desDetail;
                if(this.designer.city == this.designer.district){
                    this.designer.area = this.designer.province + this.designer.city;
                }else{
                    this.designer.area = this.designer.province + this.designer.city + this.designer.district;
                }
                this.currentAudit = val;
                if(val === 0){
                    this.title = '审核详情';
                    this.auditForm = {};
                } else {
                    this.title = '查看详情';
                }
            },
            // 确定审核
            auditSubmit(uuid){
                if(this.auditForm.status=== undefined){
                    this.$message.warning('请选择审核结果！');
                } else if(this.auditForm.status === 'REJECT' && this.auditForm.reason === undefined){
                    this.$message.warning('请输入驳回原因！');
                } else {
                    this.auditForm.uuid = uuid;
                    auditDesigner(this.auditForm).then((res)=>{
                        if(res.success){
                            this.$message.success('审核成功！');
                            this.dialogVisible = false;
                            this.search();
                            /*let data = {
                                userUuid: uuid
                            }
                            getCredentials(data).then((res) => {
                                if(res.success){
                                    let data = {
                                        backUrl: this.designer.backIdentityUrl,
                                        cardNum: this.designer.identityNo,
                                        frontUrl: this.designer.frontIdentityUrl,
                                        name: this.designer.name,
                                        gender: this.designer.sex
                                    }
                                    if(res.data.identityType == 'PERSONAL'){
                                        amendCredentials(data, uuid).then((res) => {
                                            if (res.success) {
                                                this.$message.success('审核成功！');
                                                this.dialogVisible = false;
                                                this.search();
                                            } else {
                                                this.$alert('提交失败！', "提示", {
                                                    confirmButtonText: "确定",
                                                })
                                            }
                                        })
                                    }
                                }
                            })*/

                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            // 预览模型
            handPreview(info) {
              console.log('jjjj',info )
              this.$refs.threeBox.threeAnimal(info);
              this.innerVisible = !this.innerVisible;
            },
            closeDlog(index) {
              this.innerVisible = index;
            },
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    .timeSearch {
                        background-color: #f2f4f7;
                        height: 35px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 22px;
                        margin-right: 30px;
                        border-radius: 8px;

                        span {
                            font-size: 12px;
                            color: #c0c4cc !important;
                            font-weight: normal;
                            padding-left: 15px;
                            margin-right: 5px;
                        }

                        // /deep/ .el-range-input{
                        //         background-color: #f2f4f7;
                        //             &:hover, &:focus {
                        //             background-color: #fff;
                        //             // border: 1px solid #108EE9;
                        //         }
                        // }
                        /deep/ input::-webkit-input-placeholder {
                            color: #c0c4cc;
                            font-size: 12px;
                        }

                        /deep/ .el-range-input:hover {
                            background-color: #fff !important;
                        }

                        /deep/ .el-date-editor .el-range-separator {
                            line-height: 25px;
                            color: #c0c4cc;
                        }

                        /deep/ .el-date-editor .el-range__close-icon {
                            line-height: 28px;
                        }

                        /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                            background-color: white;
                        }

                        /deep/ .el-input__inner {
                            width: 225px;
                            height: 35px;
                            min-height: 35px;
                            font-size: 12px;
                            color: #999999;
                            background-color: #f2f4f7;
                            border: 1px solid #f2f4f7;
                            border-radius: 5px;

                            .el-range-input {
                                background-color: #f2f4f7;
                            }

                            &:hover, &:focus {
                                background-color: #fff;
                                border: 1px solid #108EE9;

                            }
                        }
                    }
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-bottom:22px;
                    }

                    .resetBtn {
                        color: #333333;
                        margin-bottom:22px;
                    }
                }

                .tableContent {
                    min-height: 600px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
  //审核查看详情中title的样式
/deep/.el-dialog__header{
    border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;

  }
}

        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        // border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        // padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            font-size: 14px;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                                color: rgba(0, 0, 0, 0.85);
                            }
                            .name{
                                // color: #000;
                                color: rgba(0, 0, 0, 0.65);
                            }
                        }
                        .two-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            font-size: 14px;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                                color: rgba(0, 0, 0, 0.85);
                            }
                            .name{
                                // color: #000;
                                color: rgba(0, 0, 0, 0.65);
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        // padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    // padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/shopManager/designerManage.vue